import axios from "axios"
import { okara_api } from "../../utils/variables"

// Comment sentiment lives on the same UGC/socials intelligence backend as the
// per-platform video endpoints (see ugcExplorerApi.js) - SENTIMENT_UGC_API.md.
const SENTIMENT_ENDPOINT = `${okara_api}/sentiment-ugc/`

const authHeaders = () => {
  const token = localStorage.getItem("authToken")
  return token ? { Authorization: `Bearer ${token}` } : {}
}

// Tier gating comes back as a 403 JSON body (`code: "app_limit_reached"` /
// `"refresh_requires_upgrade"`, plus `used`/`limit`/`upgrade_to`/`redirect_to`)
// rather than a thrown network error, so the body is kept on the error for the
// UI to branch on.
const asApiError = (error) => {
  const status = error?.response?.status
  const data = error?.response?.data || {}
  const err = new Error(data.message || data.error || error.message || "Failed to load comment sentiment.")
  err.status = status
  err.data = data
  return err
}

/**
 * Read (and, on first call for an app, start) the cross-platform comment
 * sentiment run. The first call claims the app against the user's
 * `sentiment_ugc` app limit - re-reading a claimed app is free, so polling
 * this is safe once the user has asked for it.
 */
export async function fetchSentimentUgc({ appId, includeComments = true }) {
  if (!appId) throw new Error("appId is required")
  const params = { app_id: appId }
  if (includeComments) params.include_comments = true

  try {
    const response = await axios.get(SENTIMENT_ENDPOINT, { params, headers: authHeaders() })
    return response.data
  } catch (error) {
    throw asApiError(error)
  }
}
